import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetModulesList = (
    teamId?: string,
    disciplinesIds?: string[] | null,
    statuses?: number[],
    refreshKey?: number,
) => {
    const [resp, setResp] = useState<any>([]);
    const [respUntranslated, setRespUntranslated] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { i18n } = useTranslation();

    const disciplinesKey = disciplinesIds?.join(',') ?? ''
    const statusesKey = statuses?.join(',') ?? ''

    useEffect(() => {

        if (!teamId) return
        setIsLoading(true)

        let req = API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetModulesList')
            .get()
            .addQuery('teamId', teamId || '')
        if (disciplinesIds) req = req.addQuery('lMSModuleDisciplines', disciplinesIds)
        if (statuses) req = req.addQuery('statuses', statuses);
        req.send()
            .then((r) => r ? r.json() : undefined)
            .then((r) => {
                setIsLoading(false)
                setRespUntranslated(r?.data)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [teamId, disciplinesKey, statusesKey, refreshKey])

    useEffect(() => {
        setResp(API.toLang(respUntranslated, i18n.language) as any)
    }, [respUntranslated, i18n])

    return {modules: resp, modulesRaw: respUntranslated, isLoading, error};
}
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetModulesList = (
    teamId?: string,
    disciplinesIds?: string[] | null,
    statuses?: number[],
    refreshKey?: number,
) => {
    const [resp, setResp] = useState<any>([]);
    const [respUntranslated, setRespUntranslated] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { i18n } = useTranslation();

    const disciplinesKey = disciplinesIds?.join(',') ?? ''
    const statusesKey = statuses?.join(',') ?? ''

    useEffect(() => {

        if (!teamId) return
        setIsLoading(true)

        let req = API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetModulesList')
            .get()
            .addQuery('teamId', teamId || '')
        if (disciplinesIds) req = req.addQuery('lMSModuleDisciplines', disciplinesIds)
        if (statuses) req = req.addQuery('statuses', statuses);
        req.send()
            .then((r) => r ? r.json() : undefined)
            .then((r) => {
                setIsLoading(false)
                setRespUntranslated(r?.data)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [teamId, disciplinesKey, statusesKey, refreshKey])

    useEffect(() => {
        setResp(API.toLang(respUntranslated, i18n.language) as any)
    }, [respUntranslated, i18n])

    return {modules: resp, modulesRaw: respUntranslated, isLoading, error};
}
